"use strict";

/*
 \s                spaces
 \u0000-\u001f     control characters
 \u0021-\u002f     ! " # $ % & ' ( ) * + , - . /
 \u003a-\u0040     : ; < = > ? @
 \u005b-\u005e     [ \ ] ^
 \u0060            `
 \u007b-\u007e     { | } ~
 \u007f-\u00a0     control characters
 \u00a1-\u00bf     ¡ ¢ £ ¤ ¥ ¦ § ¨ © ª « ¬ ® ¯ ° ± ² ³ ´ µ ¶ · ¸ ¹ º » ¼ ½ ¾ ¿
 \u200b            zero width space character
 \u200e            left to right character
 \u202a            left to right embedding
 \u202c            Pop Directional Format [PDF]
 \uff00-\uff64     halfwidth characters
 */

/*
 facebook and twitter allow
 \u00aa            ª
 \u00b5            µ
 \u00ba            º
 */

/*
 twitter allows
 \u00b7            ·

 */


var regexs = (() => {
  return {
    // single hashtag
    hashtag: /^[^\s\u0000-\u001f\u0021-\u002f\u003a-\u0040\u005b-\u005e\u0060\u007b-\u007e\u007f-\u00a0\u00a1-\u00bf\u200b\u200e\u202a\u202c\uff00-\uff64]{2,139}$/,
  };
})();

exports = module.exports = regexs;
